import React, { useState } from "react";
import {
  Button,
  CardActions,
  CardContent,
  CardProps,
  Typography,
} from "@material-ui/core";
import { useHistory, useLocation, useParams } from "react-router";
import { CardLoading } from "../../../../components/card-loading";
import { getAnalytics } from "../../../../sdk/analytics";

export const ArtistSummaryStreams: React.FC<CardProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { artistId } = useParams<{ artistId: string }>();

  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setLoading(true);
    getAnalytics(artistId)
      .then((data) => {
        setTotal(
          data.streams.timeseries.reduce((memo, item) => memo + item.value, 0)
        );
      })
      .finally(() => setLoading(false));
  }, [artistId]);

  return (
    <CardLoading
      {...props}
      style={{ width: "200px", ...props.style }}
      loading={loading}
    >
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Streams
        </Typography>
        <Typography variant="h5" component="h2">
          {total.toLocaleString()}
        </Typography>
        <Typography color="textSecondary">This month</Typography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() =>
            history.push(`${location.pathname}/streams`, location.state)
          }
        >
          View all
        </Button>
      </CardActions>
    </CardLoading>
  );
};
